module.exports = __webpack_public_path__ + "img/logoGitlabCiCdRunner.0192e4b7.svg";